module.exports = __webpack_public_path__ + "app stores2 dental.svg?97d107b8f77da211caf30a25642e9606";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/app stores2 dental.svg
// module id = 32
// module chunks = 0